import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';

import Input from 'common/components/form/inputs/Input';
import NumberInput from 'common/components/form/inputs/NumberInput';

const Units = ({ formState }) => {
  const { fields, changeField } = useFormState(formState);

  return (
    <div>
      <Row className="no-gutters">
        <Col>
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Input label="Notation" onChange={changeField('notation')} {...fields.notation} />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Input label="Type" onChange={changeField('type')} {...fields.type} />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <NumberInput label="Ratio" onChange={changeField('ratio')} {...fields.ratio} />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Input label="Label" onChange={changeField('label')} {...fields.label} />
        </Col>
      </Row>
    </div>
  );
};

export default Units;
